const categories = [
  { icon: 'ri-movie-line', label: '影视剧场', count: '1.2万+', desc: '热门电影电视剧合集' },
  { icon: 'ri-live-line', label: '综艺娱乐', count: '8600+', desc: '热门综艺全程收录' },
  { icon: 'ri-lightbulb-line', label: '知识科普', count: '5300+', desc: '纪录片与科普内容' },
  { icon: 'ri-gamepad-line', label: '游戏天地', count: '7400+', desc: '游戏实况与攻略' },
  { icon: 'ri-music-line', label: '音乐现场', count: '6200+', desc: '演唱会与音乐节目' },
  { icon: 'ri-football-line', label: '体育赛事', count: '4800+', desc: '赛事回放与集锦' },
  { icon: 'ri-ancient-gate-line', label: '动漫番剧', count: '9100+', desc: '热门番剧追更日历' },
  { icon: 'ri-clapperboard-line', label: '短剧合集', count: '1.5万+', desc: '精品短剧每日更新' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            主题导航
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            八大内容频道，快速定位你感兴趣的领域
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <div
              key={cat.label}
              className="group bg-background-100 rounded-xl p-5 md:p-6 cursor-default transition-all duration-300 hover:bg-primary-50"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="mt-3 text-sm md:text-base font-bold text-foreground-900">
                {cat.label}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{cat.desc}</p>
              <p className="mt-2 text-xs text-primary-500 font-medium">{cat.count} 内容</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}